let dataTable = null;
let loader = document.getElementById('table-loader');

// Function to load and parse CSV data
function loadCSVData() {
    if (loader) loader.style.display = 'flex';
  
    fetch('https://cdn.shopify.com/s/files/1/0697/9066/2821/files/Chemical-Guide.csv?v=1778655498')
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
        })
        .then(csvData => {
            // Parse CSV data using PapaParse
            const results = Papa.parse(csvData, {
                header: true,
                skipEmptyLines: true
            });

            // Get the headers
            const headers = results.meta.fields;
            
            // Create header row
            const headerRow = document.createElement('tr');
            headers.forEach(header => {
                const th = document.createElement('th');
                th.textContent = header;
                headerRow.appendChild(th);
            });
            document.getElementById('tableHead').innerHTML = '';
            document.getElementById('tableHead').appendChild(headerRow);
            
            // Clear existing table body
            document.getElementById('tableBody').innerHTML = '';
            
            // Destroy existing DataTable if it exists
            if (dataTable !== null) {
                dataTable.destroy();
            }

            // Initialize DataTable with the new data
            dataTable = $('#dataTable').DataTable({
                data: results.data,
                columns: headers.slice(0, 12).map(header => ({ data: header, title: header })),
                pageLength: 10,
                responsive: true,
                dom: '<"row"<"col-sm-12 col-md-6"f><"col-sm-12 col-md-6"l>>rtip',
                order: [[0, 'asc']],
                renderer: 'bootstrap',
                language: {
                    search: "Search Chemicals:",
                    lengthMenu: "Show _MENU_ records per page",
                    info: "Showing _START_ to _END_ of _TOTAL_ records",
                    paginate: {
                        first: "First",
                        last: "Last",
                        next: "Next",
                        previous: "Previous"
                    }
                }
            });

            if (dataTable !== null) {
              if ($.fn.DataTable.isDataTable('#dataTable')) {
                  const $row = $('#dataTable_wrapper .row');
                  if ($row.length > 0) {
                    $row.after(`
                      <div class="custom-info-message" style="margin-top: 1em;">
                        <p>Please download the most recent chemical guide for your own use.
                          <a href="https://cdn.shopify.com/s/files/1/0697/9066/2821/files/Complete-Chemical-Liquid-Compatibility-Guide-_-GoatThroat-Pumps-Selection-Guide-March-2021.pdf?v=1744807673"
                             target="_blank" rel="noopener noreferrer">Download Now</a>
                        </p>
                      </div>
                    `);
                  }
              }
            }

            if (loader) loader.style.display = 'none';
        })
        .catch(error => {
            console.error(error);
            if (loader) loader.style.display = 'none';
        });
}

function initializeTable() {
  if (typeof $.fn.dataTable === 'undefined') {
    var coreScript = document.createElement('script');
    coreScript.src = "https://cdn.datatables.net/2.2.2/js/dataTables.js";
    coreScript.onload = function () {
      var bootstrapScript = document.createElement('script');
      bootstrapScript.src = "https://cdn.datatables.net/2.2.2/js/dataTables.bootstrap5.min.js";
      bootstrapScript.onload = function () {
        setTimeout(() => {
          loadCSVData();
        }, 2000);
      };
      document.head.appendChild(bootstrapScript);
    };
    document.head.appendChild(coreScript);
  } else {
    setTimeout(() => {
      loadCSVData();
    }, 2000);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth > 1180) {
    initializeTable();
  }
});

